import { useLocation, useNavigate } from "react-router-dom";
import { Button, Card, Col, Row, Skeleton, Tag } from "antd";
import { useEffect, useState } from "react";
import {
  getCIIU,
  getData,
  getEntity,
  getGroups,
  getSearcherByEntityId,
} from "../../../controllers/entities";
import "./Companies.scss";
import { RightOutlined } from "@ant-design/icons";
import { capitalizeString, getCityNameByCode } from "../../../shared/util";

const CompaniesDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [groups, setGroups] = useState([]);
  const [entity, setEntity] = useState({} as any);
  const [searchers, setSearchers] = useState([]);
  const [universities, setUniversities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ciius, setCiius] = useState([]);

  useEffect(() => {
    const getEntityData = async () => {
      setLoading(true);

      const entitie = await getEntity(location.state.companyId, "entities");

      setEntity(entitie);
      getGroupsData(entitie);
      getUniversities(location.state.companyId);
      getSearchersByEntityIdData(location.state.companyId);
      setLoading(false);
    };

    const getUniversities = async (entityId: string) => {
      const data = await getData("universities_entities", {
        filter: `filter[entities_id][_eq]=${entityId}`,
      });
      setUniversities(data);
    };

    const getGroupsData = async (entity: any) => {
      const groups = await getGroups(entity);
      setGroups(groups);
    };

    const getSearchersByEntityIdData = async (entityId: string) => {
      const searchersData = await getSearcherByEntityId(entityId);
      setSearchers(searchersData);
    };

    const getCiiuData = async () => {
      const ciiuData = await getCIIU(location.state.companyId);
      setCiius(ciiuData);
    };

    getEntityData();
    getCiiuData();
  }, [location.state.companyId]);

  const goto_entity = (params: any, entityType: string) => {
    navigate(`/entities/${params.universities_id.id}`, {
      state: { params, entityType },
    });
  };

  return (
    <div style={{ width: "100%", height: "max-content" }}>
      <Skeleton loading={loading} active className="full-width">
        <div>
          <h1 className="conection-heading-section">Datos generales</h1>
          <Card
            className="ant-card-conection"
            onClick={() => {}}
            hoverable
            style={{ width: "100%", marginBottom: 30 }}
          >
            <Row gutter={[8, 8]} style={{ width: "100%" }}>
              <Col xs={24} sm={12} md={8} lg={12}>
                <h2 className="conection-label">Nombre</h2>
                <p className="conection-value">
                  {capitalizeString(
                    entity.social_reason ||
                      entity.institution_name ||
                      entity?.nombre
                  )}
                </p>
              </Col>
              <Col xs={24} sm={12} md={8} lg={12}>
                <h2 className="conection-label">Descripción</h2>
                <p className="conection-value">
                  {capitalizeString(entity.description || "Sin descripcion")}
                </p>
              </Col>
              <Col xs={24} sm={12} md={8} lg={12}>
                <h2 className="conection-label">NIT</h2>
                <p className="conection-value">
                  {capitalizeString(entity.nit)}
                </p>
              </Col>
              <Col xs={24} sm={12} md={8} lg={12}>
                <h2 className="conection-label">
                  Actividad económica principal
                </h2>
                {ciius.map((c: any) => (
                  <div>
                    <Tag
                      color="blue"
                      style={{ marginBottom: 10 }}
                      bordered={false}
                    >
                      {capitalizeString(c.comercial_activity_id.description)}
                    </Tag>{" "}
                    <br />
                  </div>
                ))}
              </Col>
              <Col xs={24} sm={12} md={8} lg={12}>
                <h2 className="conection-label">
                  Actividades económicas secundarias
                </h2>
                {ciius.map((c: any) => (
                  <div>
                    <Tag
                      color="blue"
                      style={{ marginBottom: 10 }}
                      bordered={false}
                    >
                      {capitalizeString(c.comercial_activity_id.description)}
                    </Tag>{" "}
                    <br />
                  </div>
                ))}
              </Col>
              <Col xs={24} sm={12} md={8} lg={12}>
                <h2 className="conection-label">Grupo Económico</h2>
                <p className="conection-value">
                  {capitalizeString(entity?.economic_sector?.description || "")}
                </p>
              </Col>
            </Row>

            <Row gutter={[8, 8]} style={{ width: "100%" }}>
              <Col xs={24} sm={12} md={8} lg={12}>
                <h2 className="conection-label">Departamento</h2>
                <p className="conection-value">
                  {getCityNameByCode(entity?.city)?.departamento ||
                    entity.stateRaw ||
                    ""}
                </p>
              </Col>
              <Col xs={24} sm={12} md={8} lg={12}>
                <h2 className="conection-label">Ciudad</h2>
                <p className="conection-value">
                  {getCityNameByCode(entity?.city)?.municipio ||
                    entity.cityRaw ||
                    ""}
                </p>
              </Col>
              <Col xs={24} sm={12} md={8} lg={12}>
                <h2 className="conection-label">Características</h2>
                <p className="conection-value">
                  {capitalizeString(entity?.features || "sin definir")}
                </p>
              </Col>
            </Row>
            <Row gutter={[8, 8]} style={{ width: "100%" }}>
              <Col xs={24} sm={12} md={8} lg={12}>
                <h2 className="conection-label">
                  Reconociento Minciencias (Sí/No)
                </h2>
                <p className="conection-value">
                  {entity?.recognize_min === 1 ? "Si" : "No"}
                </p>
              </Col>
              <Col xs={24} sm={12} md={8} lg={12}>
                <h2 className="conection-label">Características</h2>
                <p className="conection-value">
                  {capitalizeString(entity?.features || "sin definir")}
                </p>
              </Col>
            </Row>
            <Row gutter={[8, 8]} style={{ width: "100%" }}>
              {entity.url ? (
                <Col xs={24} sm={12} md={8} lg={12}>
                  <h2 className="conection-label">URL</h2>
                  {entity?.url ? (
                    <Button
                      type="primary"
                      onClick={() => {
                        window.open(entity?.url, "_blank");
                      }}
                    >
                      Abrir URL
                    </Button>
                  ) : (
                    "Sin url"
                  )}
                </Col>
              ) : null}
            </Row>
          </Card>
        </div>
        <div>
          {universities.length > 0 ? (
            <>
              <h1 className="conection-heading-section">Instituciones</h1>
              <Card
                className="ant-card-conection ant-card-conection-border"
                onClick={() => {}}
                hoverable
                style={{ width: "100%", marginBottom: 30 }}
              >
                <Row gutter={[8, 8]} style={{ width: "100%" }}>
                  {universities.map((g: any) => {
                    return (
                      <Col xs={24} sm={12} md={8} lg={12}>
                        <Button
                          size="middle"
                          onClick={() => {
                            goto_entity(g, "universities");
                          }}
                          style={{
                            marginBottom: 10,
                            marginRight: 20,
                            width: "auto",
                          }}
                        >
                          {capitalizeString(
                            g.universities_id?.institution_name || ""
                          )}
                        </Button>
                      </Col>
                    );
                  })}
                </Row>
              </Card>
            </>
          ) : null}
        </div>
      </Skeleton>
    </div>
  );
};

export default CompaniesDetail;
